import { render, staticRenderFns } from "./DpGridAcoes.vue?vue&type=template&id=fd1dc3d0&"
import script from "./DpGridAcoes.js?vue&type=script&lang=js&"
export * from "./DpGridAcoes.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QTd from 'quasar/src/components/table/QTd.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QTd,QBtn});
